import { ModulesMap, ModulesConfigMap } from '../modulesMaps'

export default {
	[ModulesConfigMap[ModulesMap.DONE_WORKS_LINKS].GET_DONE_WORKS_LINKS]: {
		url:'/company/:companyId/done_works/:doneWorkId/links/'
	},
	[ModulesConfigMap[ModulesMap.DONE_WORKS_LINKS].GET_DONE_WORKS_LINK_PREVIEW]: {
		url: '/company/:companyId/done_works/:doneWorkId/links/:linkId/preview/',
	},
	[ModulesConfigMap[ModulesMap.DONE_WORKS_LINKS].GET_DONE_WORKS_LINK_POPUP]: {
		url: '/company/:companyId/done_works/:doneWorkId/links/:linkId/popup/',
	},
	[ModulesConfigMap[ModulesMap.DONE_WORKS_LINKS].GET_DONE_WORKS_LINK]: {
		url: '/company/:companyId/done_works/:doneWorkId/links/:linkId/',
	},
	[ModulesConfigMap[ModulesMap.DONE_WORKS_LINKS].CREATE_DONE_WORKS_LINK]: {
		url:'/company/:companyId/done_works/:doneWorkId/links/',
		requestOptions: {
			method: 'POST',
		},
	},
	[ModulesConfigMap[ModulesMap.DONE_WORKS_LINKS].PATCH_DONE_WORKS_LINK]: {
		url: '/company/:companyId/done_works/:doneWorkId/links/:linkId/',
		requestOptions: {
			method: 'PATCH',
		},
	},
	[ModulesConfigMap[ModulesMap.DONE_WORKS_LINKS].PUT_DONE_WORKS_LINK]: {
		url: '/company/:companyId/done_works/:doneWorkId/links/:linkId/',
		requestOptions: {
			method: 'PUT',
		},
	},
	[ModulesConfigMap[ModulesMap.DONE_WORKS_LINKS].DELETE_DONE_WORKS_LINK]: {
		url: '/company/:companyId/done_works/:doneWorkId/links/:linkId/',
		requestOptions: {
			method: 'DELETE',
		},
	},
}